module.exports = __webpack_public_path__ + "img/copper10.98e53461.gif";